import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSeo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { INSIGHTS } from "@/data/content";

const PROJECT_LINKS = {
  "radhai-estate-ready": "/projects/apratim-radhai-estate",
  "apratim-park-ready": "/projects/apratim-park",
  "pune-expansion": "/legacy",
  "landowner-partnerships": "/contact",
};

export default function InsightsPage() {
  useSeo({
    title: "Insights & Updates | Jaybhaye Realty Pvt. Ltd.",
    description:
      "Company announcements, project updates and partnership news from Jaybhaye Realty Pvt. Ltd. and Apratim Group — Aurangabad and Pune real estate developments.",
    path: "/insights",
    keywords: "Jaybhaye Realty news, Apratim Group updates, Jaybhaye Realty Pune expansion",
  });

  return (
    <div data-testid="insights-page">
      <section className="py-24 border-b border-[#12281a]/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <span className="text-xs uppercase tracking-[0.3em] text-[#b38b47] font-bold block mb-6">Insights & Media</span>
          <h1 className="font-monument text-4xl sm:text-6xl text-[#12281a] leading-[1.02] uppercase mb-6" data-testid="insights-headline">
            Company Updates
          </h1>
          <p className="text-xl text-[#2c382f] font-light leading-snug max-w-3xl">
            Announcements, project updates and partnership news — from Sambhaji Nagar to Pune.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-12">
          <div className="space-y-0">
            {INSIGHTS.map((item, i) => (
              <Reveal key={item.slug} delay={i * 80}>
                <Link
                  to={PROJECT_LINKS[item.slug] || "/insights"}
                  className="group grid grid-cols-1 md:grid-cols-12 gap-4 py-10 border-t border-[#12281a]/15 items-start"
                  data-testid={`insight-${item.slug}`}
                >
                  <div className="md:col-span-3">
                    <span className="text-[11px] uppercase tracking-[0.2em] text-[#b38b47] font-semibold">
                      {item.category}
                    </span>
                  </div>
                  <div className="md:col-span-8">
                    <h2 className="text-xl font-monument text-[#12281a] group-hover:text-[#b38b47] transition-colors mb-3">
                      {item.title}
                    </h2>
                    <p className="text-sm text-[#2c382f]/75 leading-relaxed">{item.excerpt}</p>
                  </div>
                  <div className="md:col-span-1 flex md:justify-end">
                    <ArrowUpRight size={20} className="text-[#12281a]/40 group-hover:text-[#b38b47] transition-colors" />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal delay={200}>
            <p className="mt-16 text-xs text-[#12281a]/50 uppercase tracking-widest text-center">
              More updates from Aurangabad and Pune — coming soon
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
